(() => {
  const globalKey = '__sidizProductViewResize';

  if (window[globalKey]) {
    window[globalKey]();
    return;
  }

  let frameId;
  const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

  const setContainerHeights = () => {
    const isMobile = window.matchMedia('(max-width: 1023px)').matches;

    document.querySelectorAll('.section-product-view').forEach((section) => {
      const container = section.querySelector('.container');
      const media = section.querySelector('.section-media');
      const header = section.querySelector('.wrapper--header');
      const blocks = section.querySelector('.block--wrapper');

      if (!container || !blocks) return;

      container.style.removeProperty('height');
      if (isMobile) return;

      const mediaHeight = media ? media.getBoundingClientRect().height : 0;
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const blocksHeight = blocks.getBoundingClientRect().height;
      const contentHeight = headerHeight + blocksHeight;
      const isVertical = section.classList.contains('vertical');
      const dwellHeight = isVertical
        ? clamp(window.innerHeight * 0.5, 320, 560)
        : clamp(window.innerHeight * 0.4, 240, 440);

      container.style.height = `${Math.ceil(Math.max(mediaHeight, contentHeight) + dwellHeight)}px`;
    });
  };

  const scheduleResize = () => {
    window.cancelAnimationFrame(frameId);
    frameId = window.requestAnimationFrame(setContainerHeights);
  };

  window[globalKey] = scheduleResize;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleResize, { once: true });
  } else {
    scheduleResize();
  }

  window.addEventListener('load', scheduleResize, { once: true });
  window.addEventListener('resize', scheduleResize, { passive: true });
  document.addEventListener('shopify:section:load', scheduleResize);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleResize);
  }
})();
//# sourceMappingURL=/cdn/shop/t/152/assets/section-product-view.js.map
